exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n@media (max-width: 768px) {\nul.submenu[data-v-34f6822e] {\n    display: none;\n}\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
